/** Shown in chrome; the full SHA lives in the popover and on the copy action. */
export const SHA_DISPLAY_LENGTH = 7;

export function toShortSha(sha: string): string {
  return sha.slice(0, SHA_DISPLAY_LENGTH);
}

export function hasDeployText(value: string | null | undefined): boolean {
  return typeof value === "string" && value.trim() !== "";
}

/**
 * One line an operator can paste into Slack or Sentry. Empty fields drop out
 * so a local session without CI metadata does not read as " ·  · ".
 */
export function formatBuildDiagnostic(parts: {
  environment: string;
  branch: string;
  sha: string;
  released: string | null;
}): string {
  const tokens = [parts.environment, parts.branch, toShortSha(parts.sha)].filter(
    (token) => token.trim() !== "",
  );
  if (hasDeployText(parts.released)) tokens.push(parts.released as string);
  return tokens.join(" · ");
}

function shaPrefixMatch(left: string, right: string): boolean {
  return left.length > 0 && right.length > 0 && (left.startsWith(right) || right.startsWith(left));
}

/**
 * Live SPA SHA vs a GitHub changelog row. Either side may be abbreviated.
 */
export function matchesLiveDeploySha(
  liveSha: string,
  entrySha: string,
  entryShortSha: string,
): boolean {
  const live = liveSha.trim().toLowerCase();
  if (!live) return false;
  return (
    shaPrefixMatch(live, entrySha.trim().toLowerCase()) ||
    shaPrefixMatch(live, entryShortSha.trim().toLowerCase())
  );
}
